import * as Config from '../../../config';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import './Automix.css';

import IconAutomix from './svg/IconAutomix';
import ButtonIconV2 from '../common/ButtonIconV2';

import { setUidAutomix, loadIndexAutomix, setPlayAutomix } from "./redux/actions/index";

import useCallbackAutomix from './hooks/useCallbackAutomix';
import usePlayerOverlay from '../partymode/hooks/usePlayerOverlay';

// ON LIST
function ConnectedAutomixToggleButton({
  active, idPlaylist,
  uid, className, style,
  uidAutomix, setUidAutomix, loadIndexAutomix, setPlayAutomix, storeAuth, storePopup,
  isEnabled, isSubscribed, stackAutomix
}) {
  const callbackAutomix = useCallbackAutomix(uid);
  const [isToggle, setToggle] = useState((uidAutomix === uid));
  let isLoading = Array.isArray(stackAutomix);

  // WAITING LOADING LIST
  if (!Array.isArray(stackAutomix)) {
    isLoading = (stackAutomix.idPlaylist && stackAutomix.idPlaylist === idPlaylist) ? isEnabled : false;
    isEnabled = isLoading;
  } else {
    isLoading = stackAutomix.find( x => x.uid === uid ) ? isEnabled : false;
    isEnabled = isLoading;
  }

  let onClick = () => {
    if (isLoading) {
      if (isEnabled) {
        const newStateToggle = !isToggle;
        if (callbackAutomix(newStateToggle)) {
          setToggle(newStateToggle);
          setUidAutomix((newStateToggle) ? uid : null);
          setPlayAutomix(newStateToggle);
          if (!newStateToggle) {
            loadIndexAutomix(null);
          }
        }
        if (newStateToggle && !isSubscribed) {
          storePopup.automix('.button-automix');
        }
      } else {
        storeAuth.link();
      }
    }
  }

  onClick = usePlayerOverlay(onClick, isEnabled);

  useEffect(() => {
    if (uidAutomix === null || uidAutomix !== uid) {
      setToggle(false);
    } else if (uidAutomix === uid) {
      setToggle(true);
    }
  }, [uidAutomix, uid])

  return active ? (
    <ButtonIconV2
      icon={<IconAutomix />}
      className={`button-automix ${isToggle && 'active'} ${!isEnabled && 'disable' } ${className}`}
      style={{...style}}
      label={`Automix`}
      onClick={onClick}
    />
  ) : null;
}

ConnectedAutomixToggleButton.propTypes = {
  uid: PropTypes.any.isRequired,
  idPlaylist: PropTypes.any,
  className: PropTypes.string,
  style: PropTypes.object,
  isEnabled: PropTypes.bool.isRequired,
}

const AutomixToggleButton = connect(
  state => ({
    active: state.enabledAutomix,
    uidAutomix: state.uidAutomix,
    storeAuth: state.storeAuth,
    storePopup: state.storePopup,
    stackAutomix:  state.stackAutomix,
    isSubscribed: state.isSubscribed,
    isEnabled : (state.inRoomPM) ? (state.isConnected && state.isSubscribed && !!!state.inRoomPM) : ((state.isConnected && state.isSubscribed) || Config.AUTOMIX_ALL)
  }),
  dispatch => ({
    setUidAutomix: uid => dispatch(setUidAutomix(uid)),
    loadIndexAutomix: index => dispatch(loadIndexAutomix(index)),
    setPlayAutomix: state => dispatch(setPlayAutomix(state)),
  }) )
(ConnectedAutomixToggleButton);

export default AutomixToggleButton;
